import moment from "../../moment";

// MFITT用。空席照会で選択可能な日付の期限を取得。
export const getAfterOneMonthDate = () => {
  const now = new Date();
  const nowHour = now.getHours();

  // 1ヶ月後(10:00以前の場合、1ヶ月後の同日は選択不可なので、-1日)
  let limit;
  if (nowHour > 9) {
    limit = moment(now).add(1, "M").format("YYYY-MM-DD");
  } else {
    limit = moment(now).add(1, "M").subtract(1, "d").format("YYYY-MM-DD");
  }
  console.log(limit);
  return limit;
};
